import React from "react";

export const GPTMetaContext = React.createContext({meta: undefined});
